export const environment = {
  production: false, name: 'develop', app: "Agrolog App",
  key: 'dev', build: null, api: "https://farmerdev.agrolog.io",
  ws: "wss://farmerdev.agrolog.io",
  payment: "https://farmer-payment-dev.agrolog.io",
  url: "https://dev.app.agrolog.io",
  analytics: false
};